import * as React from "react"

const SvgView = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 16.571q1.875 0 3.187-1.312c1.312-1.312 1.313-1.939 1.313-3.189q0-1.875-1.313-3.187C13.874 7.571 13.25 7.57 12 7.57q-1.875 0-3.188 1.313C7.499 10.196 7.5 10.82 7.5 12.07q0 1.875 1.312 3.188C10.124 16.571 10.75 16.57 12 16.57Zm0-1.8q-1.125 0-1.913-.787A2.6 2.6 0 0 1 9.3 12.07q0-1.125.787-1.912A2.6 2.6 0 0 1 12 9.37q1.125 0 1.912.788.788.787.788 1.912c0 1.125-.263 1.388-.788 1.913A2.6 2.6 0 0 1 12 14.77Zm0 4.8q-3.349 0-6.113-1.8-2.761-1.8-4.362-4.75a1.9 1.9 0 0 1-.187-1.438 2 2 0 0 1 .187-.462q1.6-2.95 4.362-4.75T12 4.571q3.35 0 6.112 1.8t4.363 4.75a1.9 1.9 0 0 1 .188 1.438 2 2 0 0 1-.188.462q-1.6 2.95-4.363 4.75-2.762 1.8-6.112 1.8m0-2a9.54 9.54 0 0 0 5.187-1.487A9.77 9.77 0 0 0 20.8 12.07a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6.57a9.55 9.55 0 0 0-5.188 1.49A9.77 9.77 0 0 0 3.2 12.07a9.77 9.77 0 0 0 3.612 4.013A9.54 9.54 0 0 0 12 17.57Z" />
  </svg>
)
export default SvgView
